import { useTranslation } from "react-i18next";
import { useTheme } from "styled-components";

import type { HaNTextRange } from "@lib/logic";
import type { RoomResource } from "@lib/store";
import { pickUsingStringAsIndex } from "@lib/utils";
import { useRoomImage } from "@hooks";
import { ModalCellItemIcon } from "@molecules";

import { HaNSearchResultCell } from "./HaNSearchResultCell";

// The picture is drawn at 48px, so it's requested at a few times that for sharp screens
const IMAGE_WIDTH = Math.round(48 * window.devicePixelRatio * 4);

type RoomSearchResultProps = {
  room: RoomResource;
  ranges: HaNTextRange[];
};

export const RoomSearchResult = ({ room, ranges }: RoomSearchResultProps) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const email = room.data.email || room.name;
  const imageURL = useRoomImage(email, room.data.roomPictureHash ?? undefined, room.buildingId, IMAGE_WIDTH);

  return (
    <HaNSearchResultCell
      icon={
        <ModalCellItemIcon
          className="flex-none"
          imageURL={imageURL}
          backgroundColor={pickUsingStringAsIndex(email, theme.avatar.colors)}
          icon="meetingRoom"
        />
      }
      name={room.name}
      ranges={ranges}
      details={t("meeting:MeetingRoomBasicInfo", { count: room.data.capacity, floorName: room.floorName })}
    />
  );
};
